<template>
  <div class="brand-image">
    <a :href="link" v-if="link">
      <img class="brand-image__img" :src="src" />
    </a>
    <img v-else class="brand-image__img" :src="src" />
  </div>
</template>

<script>
export default {
  name: "M4BrandImage",
  props: {
    src: String,
    link: String
  }
};
</script>
